import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { useLang } from "@/i18n";

export default function MostRead({ items }) {
  const { t } = useLang();
  return (
    <aside className="lg:sticky lg:top-32" data-testid="most-read-sidebar">
      <div className="flex items-center gap-2 pb-3 mb-4 border-b-2 border-white">
        <TrendingUp size={18} className="text-red-500" />
        <h3 className="headline text-xl uppercase tracking-tight text-white">
          {t("most_read")}
        </h3>
      </div>
      <ol className="space-y-5">
        {items?.slice(0, 5).map((item, idx) => (
          <li key={item.id} data-testid={`most-read-item-${idx}`}>
            <Link to={`/news/${item.id}`} className="group flex gap-4 items-start">
              <span className="headline text-5xl leading-none text-neutral-800 group-hover:text-red-500 transition-colors flex-shrink-0 select-none">
                {idx + 1}
              </span>
              <div className="flex-1 pt-1">
                <h4 className="font-heading font-semibold text-sm leading-snug text-neutral-100 group-hover:text-red-500 transition-colors line-clamp-3">
                  {item.title}
                </h4>
                <p className="text-[11px] font-mono uppercase tracking-wider text-neutral-500 mt-1">
                  {item.source} · {item.views.toLocaleString()} views
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}
